import { Injectable } from '@angular/core'
import { ReplaySubject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class ViewportService {
  public isTouchResolution = new ReplaySubject(1)
}
